import { Label } from "../../ui/label";
import { Input } from "../../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select";
import AdvancedSection from "./AdvancedSection";

export default function CargasModelConfig({ config, onChange }) {
  const cargasModel = config?.cargasModel || (config?.cargasPricing ? "cargasPricing" : "descuentosCargas");
  return (
    <div className="mb-4">
      <h5 className="text-sm font-medium text-gray-700 mb-2">Modelo de cargas familiares</h5>
      <Select value={cargasModel} onValueChange={(v) => onChange("cargasModel", v)}>
        <SelectTrigger><SelectValue placeholder="Seleccionar modelo" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="descuentosCargas">Descuento sobre titular</SelectItem>
          <SelectItem value="cargasPricing">Precio por carga</SelectItem>
        </SelectContent>
      </Select>

      {cargasModel === "cargasPricing" && (
        <div className="mt-3">
          <Label className="text-xs text-gray-500">Modo</Label>
          <Select
            value={config?.cargasPricing?.mode || "absolute"}
            onValueChange={(v) => onChange("cargasPricing.mode", v)}
          >
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="absolute">Absoluto</SelectItem>
              <SelectItem value="discount">Descuento</SelectItem>
            </SelectContent>
          </Select>
          <AdvancedSection>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label className="text-xs text-gray-500">Tabla</Label>
                <Input value={config?.cargasPricing?.tabla || ""} onChange={(e) => onChange("cargasPricing.tabla", e.target.value)} placeholder="precios_carga" />
              </div>
              <div>
                <Label className="text-xs text-gray-500">Campo Resultado</Label>
                <Input value={config?.cargasPricing?.campoResultado || ""} onChange={(e) => onChange("cargasPricing.campoResultado", e.target.value)} placeholder="precio_uf" />
              </div>
            </div>
          </AdvancedSection>
        </div>
      )}

      {cargasModel === "descuentosCargas" && (
        <AdvancedSection>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <Label className="text-xs text-gray-500">Tabla</Label>
              <Input value={config?.descuentosCargas?.tabla || ""} onChange={(e) => onChange("descuentosCargas.tabla", e.target.value)} placeholder="descuentos_base" />
            </div>
            <div>
              <Label className="text-xs text-gray-500">Aplicación</Label>
              <Input value={config?.descuentosCargas?.aplicacion || ""} onChange={(e) => onChange("descuentosCargas.aplicacion", e.target.value)} placeholder="descuento_sobre_titular" />
            </div>
            <div>
              <Label className="text-xs text-gray-500">Campo Resultado</Label>
              <Input value={config?.descuentosCargas?.campoResultado || ""} onChange={(e) => onChange("descuentosCargas.campoResultado", e.target.value)} placeholder="porcentaje" />
            </div>
          </div>
        </AdvancedSection>
      )}
    </div>
  );
}
